let ProjectionPointsType = {
    SET_PROJECTION_POINTS_TYPE: 'SET_PROJECTION_POINTS_TYPE',
};

export default ProjectionPointsType;
